import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { text: String }

  connect() {
    this.tooltip = null
  }

  show() {
    if (this.tooltip) return

    const el = document.createElement("div")
    el.textContent = this.textValue
    el.className =
      "fixed z-[9999] px-2 py-1 text-xs font-medium text-white bg-gray-900 rounded shadow-lg whitespace-nowrap pointer-events-none"
    document.body.appendChild(el)
    this.tooltip = el

    const rect = this.element.getBoundingClientRect()
    el.style.top = `${rect.top + rect.height / 2}px`
    el.style.left = `${rect.right + 8}px`
    el.style.transform = "translateY(-50%)"
  }

  hide() {
    if (this.tooltip) {
      this.tooltip.remove()
      this.tooltip = null
    }
  }

  disconnect() {
    this.hide()
  }
}
